import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { api } from '../../api/client';
export default function LibrariesTab() {
    const [libs, setLibs] = useState(null);
    const [draft, setDraft] = useState({});
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        api.getLibraries().then(({ libraries }) => {
            setLibs(libraries);
            setDraft(Object.fromEntries(Object.entries(libraries).map(([k, v]) => [k, v.enabled])));
        });
    }, []);
    async function save() {
        setBusy(true);
        setError(null);
        try {
            const { libraries } = await api.putLibraries(draft);
            setLibs(libraries);
        }
        catch (e) {
            setError(e?.message ?? 'Save failed');
        }
        finally {
            setBusy(false);
        }
    }
    if (!libs)
        return _jsx("div", { className: "muted", children: "Loading\u2026" });
    const dirty = Object.entries(draft).some(([k, v]) => libs[k]?.enabled !== v);
    return (_jsxs("div", { className: "settings-tab", children: [_jsxs("div", { className: "tab-head", children: [_jsxs("div", { children: [_jsx("h2", { children: "Libraries" }), _jsxs("p", { className: "muted small", children: ["Opt-in client-side libraries. Off by default. Pages can also opt in via the ", _jsx("code", { children: "requires" }), " array."] })] }), _jsxs("div", { className: "actions", children: [_jsx("button", { className: "ghost", disabled: !dirty || busy, onClick: () => setDraft(Object.fromEntries(Object.entries(libs).map(([k, v]) => [k, v.enabled]))), children: "Reset" }), _jsx("button", { disabled: !dirty || busy, onClick: save, children: busy ? 'Saving…' : 'Save' })] })] }), error && _jsx("div", { className: "err small pad-y", children: error }), _jsx("div", { className: "lib-list", children: Object.entries(libs).map(([key, info]) => (_jsxs("label", { className: "lib-row", children: [_jsx("input", { type: "checkbox", checked: draft[key] ?? false, onChange: (e) => setDraft((d) => ({ ...d, [key]: e.target.checked })) }), _jsxs("div", { children: [_jsx("div", { className: "lib-name", children: key }), _jsx("div", { className: "muted small", children: info.description })] })] }, key))) })] }));
}
